import { render, staticRenderFns } from "./batchAdjustPermissions.vue?vue&type=template&id=3945e1d0&scoped=true&"
import script from "./batchAdjustPermissions.vue?vue&type=script&lang=js&"
export * from "./batchAdjustPermissions.vue?vue&type=script&lang=js&"
import style0 from "./batchAdjustPermissions.vue?vue&type=style&index=0&id=3945e1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945e1d0",
  null
  
)

export default component.exports